import { defaultTheme, whiteColor, colorShade } from '@twnel/web-components';
import {
  CALL_API, CALL_API_DESCRIPTION, CALL_API_LABEL,
  CALL_FUNCTION, CALL_FUNCTION_DESCRIPTION, CALL_FUNCTION_LABEL,
  CLONE, CLONE_LABEL,
  DELETE, DELETE_LABEL,
  EVAL_NEXT, EVAL_NEXT_DESCRIPTION, EVAL_NEXT_LABEL,
  MAP_RESULT, MAP_RESULT_DESCRIPTION, MAP_RESULT_LABEL,
  SEND_MESSAGE, SEND_MESSAGE_DESCRIPTION, SEND_MESSAGE_LABEL,
  STORE_DATA, STORE_DATA_DESCRIPTION, STORE_DATA_LABEL,
  CONDITIONAL_STEP, CONDITIONAL_STEP_LABEL, CONDITIONAL_STEP_DESCRIPTION,
  STORE_FILE, STORE_FILE_DESCRIPTION, STORE_FILE_LABEL, COMMENT,
  COMMENT_LABEL,
} from 'app-constants/actionTypes';

export const MESSAGE_GROUP_COLOR = 'brandAccent';
export const FUNCTION_GROUP_COLOR = 'success';
export const DATA_GROUP_COLOR = 'brandComplement';
export const NOT_DEFINED_COLOR = 'error';

const actionsGroups = (theme = defaultTheme) => [
  {
    name: SEND_MESSAGE,
    label: SEND_MESSAGE_LABEL,
    color: theme[MESSAGE_GROUP_COLOR],
    description: SEND_MESSAGE_DESCRIPTION,
    style: {
      icon: 'fas fa-envelope',
      type: {
        backgroundColor: theme[MESSAGE_GROUP_COLOR],
      },
      node: {
        selectedColor: `2px solid ${theme[MESSAGE_GROUP_COLOR]}`,
        unselectedColor: `1px solid ${theme[MESSAGE_GROUP_COLOR]}`,
        background: 'rgba(255, 255, 255, 1)',
        width: '240px',
      },
      input: {
        fontWeight: '700',
        paddingTop: '10px',
        border: 'unset',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        flexGrow: '1',
      },
    },
  },
  {
    name: CALL_API,
    label: CALL_API_LABEL,
    color: theme[FUNCTION_GROUP_COLOR],
    description: CALL_API_DESCRIPTION,
    style: {
      icon: 'fas fa-network-wired',
      type: {
        backgroundColor: theme[FUNCTION_GROUP_COLOR],
      },
      node: {
        selectedColor: `2px solid ${theme[FUNCTION_GROUP_COLOR]}`,
        unselectedColor: `1px solid ${theme[FUNCTION_GROUP_COLOR]}`,
        background: 'rgba(255, 255, 255, 1)',
        width: '240px',
      },
      input: {
        paddingTop: '10px',
        border: 'unset',
        fontWeight: '700',
        flexGrow: '1',
      },
    },
  },
  {
    name: CALL_FUNCTION,
    label: CALL_FUNCTION_LABEL,
    color: theme[FUNCTION_GROUP_COLOR],
    description: CALL_FUNCTION_DESCRIPTION,
    style: {
      icon: 'fas fa-terminal',
      type: {
        backgroundColor: theme[FUNCTION_GROUP_COLOR],
      },
      node: {
        selectedColor: `2px solid ${theme[FUNCTION_GROUP_COLOR]}`,
        unselectedColor: `1px solid ${theme[FUNCTION_GROUP_COLOR]}`,
        background: 'rgba(255, 255, 255, 1)',
        width: '240px',
      },
      input: {
        paddingTop: '10px',
        border: 'unset',
        fontWeight: '700',
        flexGrow: '1',
      },
    },
  },
  {
    name: EVAL_NEXT,
    label: EVAL_NEXT_LABEL,
    color: theme[FUNCTION_GROUP_COLOR],
    description: EVAL_NEXT_DESCRIPTION,
    style: {
      icon: 'fas fa-step-forward',
      type: {
        backgroundColor: theme[FUNCTION_GROUP_COLOR],
      },
      node: {
        selectedColor: `2px solid ${theme[FUNCTION_GROUP_COLOR]}`,
        unselectedColor: `1px solid ${theme[FUNCTION_GROUP_COLOR]}`,
        background: 'rgba(255, 255, 255, 1)',
        width: '240px',
      },
      input: {
        paddingTop: '10px',
        border: 'unset',
        fontWeight: '700',
        flexGrow: '1',
      },
    },
  },
  {
    name: MAP_RESULT,
    label: MAP_RESULT_LABEL,
    color: theme[DATA_GROUP_COLOR],
    description: MAP_RESULT_DESCRIPTION,
    style: {
      icon: 'fas fa-long-arrow-alt-right',
      type: {
        backgroundColor: theme[DATA_GROUP_COLOR],
      },
      node: {
        selectedColor: `2px solid ${theme[DATA_GROUP_COLOR]}`,
        unselectedColor: `1px solid ${theme[DATA_GROUP_COLOR]}`,
        background: 'rgba(255, 255, 255, 1)',
        width: '240px',
      },
      input: {
        paddingTop: '10px',
        border: 'unset',
        fontWeight: '700',
        flexGrow: '1',
      },
    },
  },
  {
    name: STORE_DATA,
    label: STORE_DATA_LABEL,
    color: theme[DATA_GROUP_COLOR],
    description: STORE_DATA_DESCRIPTION,
    style: {
      icon: 'fas fa-database',
      type: {
        backgroundColor: theme[DATA_GROUP_COLOR],
      },
      node: {
        selectedColor: `2px solid ${theme[DATA_GROUP_COLOR]}`,
        unselectedColor: `1px solid ${theme[DATA_GROUP_COLOR]}`,
        background: 'rgba(255, 255, 255, 1)',
        width: '240px',
      },
      input: {
        paddingTop: '10px',
        border: 'unset',
        fontWeight: '700',
        flexGrow: '1',
      },
    },
  },
  {
    name: CONDITIONAL_STEP,
    label: CONDITIONAL_STEP_LABEL,
    color: theme[FUNCTION_GROUP_COLOR],
    description: CONDITIONAL_STEP_DESCRIPTION,
    style: {
      icon: 'fas fa-step-forward',
      type: {
        backgroundColor: theme[FUNCTION_GROUP_COLOR],
      },
      node: {
        selectedColor: `2px solid ${theme[FUNCTION_GROUP_COLOR]}`,
        unselectedColor: `1px solid ${theme[FUNCTION_GROUP_COLOR]}`,
        background: 'rgba(255, 255, 255, 1)',
        width: '240px',
      },
      input: {
        fontWeight: '700',
        paddingTop: '10px',
        border: 'unset',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        flexGrow: '1',
      },
    },
  },
  {
    name: STORE_FILE,
    label: STORE_FILE_LABEL,
    color: theme[DATA_GROUP_COLOR],
    description: STORE_FILE_DESCRIPTION,
    style: {
      icon: 'fas fa-database',
      type: {
        backgroundColor: theme[DATA_GROUP_COLOR],
      },
      node: {
        selectedColor: `2px solid ${theme[DATA_GROUP_COLOR]}`,
        unselectedColor: `1px solid ${theme[DATA_GROUP_COLOR]}`,
        background: 'rgba(255, 255, 255, 1)',
        width: '240px',
      },
      input: {
        paddingTop: '10px',
        border: 'unset',
        fontWeight: '700',
        flexGrow: '1',
      },
    },
  },
  {
    name: COMMENT,
    label: COMMENT_LABEL,
    color: colorShade(1, theme.warning),
    description: SEND_MESSAGE_DESCRIPTION,
    style: {
      icon: 'fas fa-comment',
      type: {
        backgroundColor: whiteColor(3, theme.warning),
        borderRadius: '2px',
      },
      node: {
        selectedColor: `1px solid ${whiteColor(1, theme.warning)}`,
        unselectedColor: `0.5px solid ${whiteColor(1, theme.warning)}`,
        background: whiteColor(8, theme.warning),
        width: '240px',
        border: 'unset',
      },
      input: {
        fontWeight: '700',
        paddingTop: '10px',
        border: 'unset',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        flexGrow: '1',
      },
    },
  },
];

export const nodeOptions = (theme = defaultTheme) => [
  {
    name: CLONE,
    label: CLONE_LABEL,
    color: theme[MESSAGE_GROUP_COLOR],
    style: {
      icon: 'fas fa-clone',
      type: {
        backgroundColor: theme[MESSAGE_GROUP_COLOR],
      },
    },
  },
  {
    name: DELETE,
    label: DELETE_LABEL,
    color: theme[NOT_DEFINED_COLOR],
    style: {
      icon: 'fas fa-trash',
      type: {
        backgroundColor: theme[NOT_DEFINED_COLOR],
      },
    },
  },
];

export default actionsGroups;
